const StoreIntFeatureFlags = {
  application: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  storeInt: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  saasMarketPlaceEndpoint : {
    Production: "",
    PreProduction: "",
    UAT: "https://saas.non-prod.dev.telstra.com/nonprod/remoteEntry.js",
    SVT: "",
    QA: "https://saas.non-prod.dev.telstra.com/nonprod/remoteEntry.js",
    Mock: "https://saas.non-prod.dev.telstra.com/nonprod/remoteEntry.js",
    Development: "https://saas.non-prod.dev.telstra.com/nonprod/remoteEntry.js",
    Local: "https://saas.non-prod.dev.telstra.com/nonprod/remoteEntry.js",
  },
  saasMarketPlaceName : {
    Production: "sassmp_ui",
    PreProduction: "sassmp_ui",
    UAT: "sassmp_ui",
    SVT: "sassmp_ui",
    QA: "sassmp_ui",
    Mock: "sassmp_ui",
    Development: "sassmp_ui",
    Local: "sassmp_ui",
  }

}

export default StoreIntFeatureFlags
